import { Injectable } from '@angular/core';
import { SocketIoService } from './../socket-io/socket-io.service';
import { VisibilityState } from './page-visibility.model';

@Injectable({
  providedIn: 'root',
})
export class PageVisibilityService {
  TIMEOUT_DURATION = 300000; // 5 Minutes
  inactivityTimeout = null;
  isInactive = false;

  constructor(private socketIoService: SocketIoService) {}

  initialize(): void {
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this), false);
  }

  private handleVisibilityChange(): void {
    const isTabHidden = document.visibilityState === VisibilityState.Hidden;

    if (isTabHidden) {
      this.inactivityTimeout = setTimeout(
        this.onSwitchToInactive.bind(this),
        this.TIMEOUT_DURATION
      );
    } else {
      clearTimeout(this.inactivityTimeout);

      if (this.isInactive) {
        this.onSwitchToActive();
      }
    }
  }

  private onSwitchToInactive(): void {
    console.log('%cDisconnected from websockets due to inactivity', 'font-weight: 600;');
    this.isInactive = true;

    this.socketIoService.disconnect();
  }

  private onSwitchToActive(): void {
    this.isInactive = false;

    const websocketAlreadyConnected = !!this.socketIoService.socketId;
    if (!websocketAlreadyConnected) {
      this.socketIoService.connectToSocket();
    }
  }
}
